import { DMs } from "../models/DMs";

const DMStore = DMs.create({
  username: "",
  DM: []
});

export default DMStore;
